(() => {
  const root = document.documentElement;
  root.classList.add('js');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initNav() {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll('.em-nav a, .em-drawer__nav a').forEach((a) => {
      try {
        const href = new URL(a.href, location.origin).pathname.replace(/\/+$/, '') || '/';
        if (href === path && path !== '/') a.setAttribute('aria-current', 'page');
      } catch (_) {}
    });
    const group =
      document.body.dataset.group ||
      (path.includes('sports') ? 'sports' : path.includes('keepsake') ? 'keepsakes' : '');
    if (group) {
      document.querySelector('[aria-controls="menu-' + group + '"]')?.setAttribute('aria-current', 'true');
    }

    const items = [...document.querySelectorAll('[data-menu]')];
    const setMenu = (targetItem, open) => {
      items.forEach((it) => {
        const isOpen = it === targetItem ? open : false;
        it.toggleAttribute('data-open', isOpen);
        it.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', String(isOpen));
      });
    };
    items.forEach((item) => {
      const toggle = item.querySelector('[data-menu-toggle]');
      if (!toggle || toggle.dataset.bound) return;
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', () => setMenu(item, !item.hasAttribute('data-open')));
    });
    document.addEventListener('click', (e) => {
      if (!items.some((it) => it.contains(e.target))) setMenu(null, false);
    });

    const drawer = document.querySelector('[data-drawer]');
    const opener = document.querySelector('[data-drawer-open]');
    if (drawer && opener && !opener.dataset.bound) {
      opener.dataset.bound = '1';
      const focusables = () => drawer.querySelectorAll('a[href], button');
      const setDrawer = (open) => {
        drawer.toggleAttribute('data-open', open);
        opener.setAttribute('aria-expanded', String(open));
        root.classList.toggle('em-lock', open);
        if (open) focusables()[0]?.focus();
        else opener.focus();
      };
      drawer.inert = true;
      opener.addEventListener('click', () => {
        drawer.inert = false;
        setDrawer(true);
      });
      drawer.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) {
          setDrawer(false);
          setTimeout(() => (drawer.inert = true), reduced ? 0 : 260);
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          setMenu(null, false);
          if (drawer.hasAttribute('data-open')) {
            setDrawer(false);
            drawer.inert = true;
          }
        }
        if (e.key === 'Tab' && drawer.hasAttribute('data-open')) {
          const list = [...focusables()];
          const first = list[0];
          const last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last?.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first?.focus();
          }
        }
      });
      matchMedia('(min-width: 990px)').addEventListener('change', (m) => {
        if (m.matches && drawer.hasAttribute('data-open')) {
          setDrawer(false);
          drawer.inert = true;
        }
      });
    }

    const cartBtn = document.querySelector('[data-em-cart-trigger]');
    if (cartBtn && !cartBtn.dataset.bound) {
      cartBtn.dataset.bound = '1';
      cartBtn.addEventListener('click', (e) => {
        const cartDrawer = document.querySelector('#cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          e.preventDefault();
          cartDrawer.open();
        }
      });
      // The count follows the cart. Horizon and Shopify's standard actions (an app's Shopify.actions.updateCart) send
      // shopify:cart:lines-update; cart:update is the name older Horizon code used.
      const showCount = (e) => {
        e.promise?.then((result) => {
          const cart = result?.cart;
          const detail = result?.detail;
          if (detail?.didError) return;
          const count = cart?.totalQuantity ?? detail?.itemCount;
          if (!Number.isInteger(count)) return;
          const badge = cartBtn.querySelector('.em-cart__count');
          if (badge) {
            badge.textContent = String(count);
            badge.hidden = count === 0;
          }
          cartBtn.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' items' : 'Cart, empty');
        }).catch(() => {});
      };
      document.addEventListener('shopify:cart:lines-update', showCount);
      document.addEventListener('cart:update', showCount);
    }
  }

  function initAnnounce() {
    const bar = document.querySelector('[data-announce]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    const items = [...bar.querySelectorAll('li[data-slot]:not([data-off])')];
    items.forEach((li, i) => (li.hidden = i !== 0));
    if (reduced || items.length < 2) return;
    let i = 0;
    let paused = false;
    ['mouseenter', 'focusin'].forEach((ev) => bar.addEventListener(ev, () => (paused = true)));
    ['mouseleave', 'focusout'].forEach((ev) => bar.addEventListener(ev, () => (paused = false)));
    setInterval(() => {
      if (paused) return;
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 6000);
  }

  function initHeader() {
    const header = document.querySelector('.em-header');
    if (!header || header.dataset.scrollBound) return;
    header.dataset.scrollBound = '1';
    const on = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    addEventListener('scroll', on, { passive: true });
    on();
  }

  function initFilters() {
    const chips = [...document.querySelectorAll('[data-filter]')];
    if (!chips.length) return;
    const status = document.querySelector('[data-filter-status]');
    const apply = (key) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.filter === key)));
      let shown = 0;
      document.querySelectorAll('[data-product]').forEach((card) => {
        const tags = (card.dataset.tags || '').split(' ');
        const ok = key === 'all' || tags.includes(key);
        card.hidden = !ok;
        if (ok) shown += 1;
      });
      document.querySelectorAll('[data-filter-group]').forEach((g) => {
        g.hidden = ![...g.querySelectorAll('[data-product]')].some((c) => !c.hidden);
      });
      if (status) status.textContent = 'Showing ' + shown + ' styles';
    };
    chips.forEach((c) => {
      if (c.dataset.bound) return;
      c.dataset.bound = '1';
      c.addEventListener('click', () => apply(c.dataset.filter));
    });
  }

  function initPicker() {
    document.querySelectorAll('[data-picker] a[href^="#"]').forEach((a) => {
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', (e) => {
        const target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        target.classList.add('em-card--flash');
        setTimeout(() => target.classList.remove('em-card--flash'), 3000);
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach((g) => {
      if (g.dataset.bound) return;
      g.dataset.bound = '1';
      const track = g.querySelector('[data-track]');
      if (!track) return;
      const slides = [...track.children];
      const thumbs = [...g.querySelectorAll('[data-thumb]')];
      const count = g.querySelector('[data-count]');
      const at = (i) => slides[i].offsetLeft - slides[0].offsetLeft;
      const current = () =>
        slides.reduce((best, s, i) => (Math.abs(at(i) - track.scrollLeft) < Math.abs(at(best) - track.scrollLeft) ? i : best), 0);
      const go = (i) => {
        const n = (i + slides.length) % slides.length;
        track.scrollTo({ left: at(n), behavior: reduced ? 'auto' : 'smooth' });
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      g.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => go(current() + Number(b.dataset.step))));
      let frame;
      track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const n = current();
            thumbs.forEach((t, i) => (i === n ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
            if (count) count.textContent = (n + 1) + ' / ' + slides.length;
          });
        },
        { passive: true }
      );
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') (e.preventDefault(), go(current() + 1));
        if (e.key === 'ArrowLeft') (e.preventDefault(), go(current() - 1));
      });
    });
  }

  function initSticky() {
    const bar = document.querySelector('[data-sticky-bar]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    document.body.dataset.hasSticky = '';
    const target = document.querySelector(bar.dataset.stickyAfter || '[data-section]');
    if (!target) return;
    if (bar.dataset.stickyMode === 'offscreen') {
      let frame;
      const update = () => {
        const r = target.getBoundingClientRect();
        const away = r.bottom < 0 || r.top > window.innerHeight;
        bar.toggleAttribute('data-show', away && window.scrollY > 200);
      };
      addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      update();
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(
      ([entry]) => bar.toggleAttribute('data-show', !entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    ).observe(target);
  }

  function initNewsletter() {
    document.querySelectorAll('[data-newsletter]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      const msg = form.parentElement.querySelector('[data-newsletter-msg]');
      const input = form.querySelector('input[type="email"]');
      form.addEventListener('submit', (e) => {
        const ok = input && input.checkValidity() && input.value;
        if (!ok) {
          e.preventDefault();
          if (msg) {
            msg.setAttribute('role', 'alert');
            msg.textContent = "That email doesn't look right. Mind checking it?";
          }
          return;
        }
        if (form.hasAttribute('data-demo')) {
          e.preventDefault();
          if (msg) {
            msg.setAttribute('role', 'status');
            msg.textContent = form.dataset.success || "You're on the list. Watch for a welcome note from us.";
          }
          form.hidden = true;
        }
      });
    });
  }

  function initCopy() {
    document.querySelectorAll('[data-copy-from]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      const label = b.textContent;
      b.addEventListener('click', async () => {
        const text = document.querySelector(b.dataset.copyFrom)?.textContent.trim() || '';
        try {
          await navigator.clipboard.writeText(text);
          b.textContent = 'Copied';
        } catch (_) {
          b.textContent = 'Select the text and copy';
        }
        setTimeout(() => (b.textContent = label), 2000);
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach((box) => {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      const tabs = [...box.querySelectorAll('[role="tab"]')];
      const panels = [...box.querySelectorAll('[role="tabpanel"]')];
      const select = (i) => {
        tabs.forEach((t, n) => t.setAttribute('aria-selected', String(n === i)));
        panels.forEach((p, n) => (p.hidden = n !== i));
      };
      tabs.forEach((t, i) => t.addEventListener('click', () => select(i)));
      select(0);
    });
  }

  function initVideos() {
    if (!reduced) return;
    document.querySelectorAll('video[data-auto-video]').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  function initAll() {
    initNav();
    initAnnounce();
    initHeader();
    initFilters();
    initPicker();
    initGallery();
    initSticky();
    initNewsletter();
    initVideos();
    initCopy();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
